<template>
<div class="container">

  <ul class="docCreation" v-if="to_editor === 'true'">
    <li v-for="t in types">
      <router-link :to="'/docs/edit/false/' + t._id">{{t.name}}</router-link>
    </li>
  </ul>

  <ul class="docCreation" v-else>
    <li v-for="t in types">
      <router-link :to="'/docs/make/' + t._id + '/' + matter_id">{{t.name}}</router-link>
    </li>
  </ul>

  <button v-if="to_editor === 'true'" class="btn btn-primary" style="float:left; clear:both">
    <router-link :to="'/docs/edit/true/' + matter_type"><i class="icon icon-plus"></i> New</router-link>
  </button>

</div>
</template>

<script>
import axios from 'axios'
import { bus } from '@/components/bus.js'
export default {
  name: 'chooseDocType',
  props: {
    to_editor: String,  // should the next screen be the editor?
    matter_type: String, // _id of matter type
    matter_id: String
  },
  data () {
    return {
      types: [],
      editing: null,
      newType: {
        matter_type: this.matter_type,
        name: ''
      }
    }
  },
  created () {
    this.getTypes()
    let title = 'Draft a document'
    if (this.to_editor === 'true') title = 'Edit a Document'
    this.$root.$data.pageTitle = title
  },
  mounted () {
    bus.$emit('in_editor', true) // inform the menu
  },
  destroyed () {
    bus.$emit('in_editor', false)
  },
  methods: {
    getTypes () {
      if (!this.matter_type) return
      axios.get('/api/types/docs/' + this.matter_type)
      .then(res => {
        if (res.status === 200) {
          this.types = res.data
        }
      })
    },
    saveType (t) {
      axios.post('/api/types/docs/save', t)
      .then(res => {
        if (res.status === 200) {
          this.getTypes()
          this.editing = null
          this.newType.name = ''
        }
      })
      .catch(e => {
        console.log(e.response.data)
      })
    },
    delType (t) {
      axios.post('/api/types/docs/delete', t)
      .then(res => {
        if (res.status === 200) {
          this.getTypes()
          this.editing = null
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// chooseDocType.vue?779dfa90